import { gql } from '@apollo/client'
// graphql
import { GROUP_SECURITY_DETAILS_FRAGMENT } from './queries'

export const GROUP_SECURITY_CREATE_MUTATION = gql`
  mutation GROUP_SECURITY_CREATE_MUTATION($companyId: ID, $input: SecurityGroupInput!) {
    securityGroupCreate(companyId: $companyId, input: $input) {
      data {
        ...GROUP_SECURITY_DETAILS
      }
    }
  }
  ${GROUP_SECURITY_DETAILS_FRAGMENT}
`

export const GROUP_SECURITY_DELETE_MUTATION = gql`
  mutation GROUP_SECURITY_DELETE_MUTATION($id: ID!, $companyId: ID) {
    securityGroupDelete(id: $id, companyId: $companyId) {
      ok
    }
  }
`

export const GROUP_SECURITY_UPDATE_MUTATION = gql`
  mutation GROUP_SECURITY_UPDATE_MUTATION($id: ID!, $companyId: ID, $input: SecurityGroupInput!) {
    securityGroupUpdate(id: $id, companyId: $companyId, input: $input) {
      data {
        ...GROUP_SECURITY_DETAILS
      }
    }
  }
  ${GROUP_SECURITY_DETAILS_FRAGMENT}
`
